const Questions = () => {
  return (
    <>
      <section class='relative py-16 bg-white min-w-screen animation-fade animation-delay'>
        <div class='container px-0 px-8 mx-auto sm:px-12 xl:px-5'>
          <h3 class='mt-1 text-2xl font-bold text-left text-gray-800 sm:mx-6 sm:text-3xl md:text-4xl lg:text-5xl sm:text-center sm:mx-0'>
            Visas & Customs Formalities
          </h3>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              How much will I be charged for the ETA?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              The non-refundable ETA processing charge for a Tourist visa with
              Double Entry for 30 days for citizens of South Asian Association
              for Regional Cooperation (SAARC) countries amounts to US $15. For
              those from all other countries, it will cost US $30.
            </p>
          </div>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              Am I required to get an ETA?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              It’s necessary for citizens of all countries except for those of
              The Republic of Singapore and of The Republic of Maldives to get
              an ETA to visit Sri Lanka.
            </p>
          </div>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              What is an Electronic Travel Authorization (ETA) ?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              The Electronic Travel Authorization (ETA) is an official
              authorization for a Short Visit to Sri Lanka issued via an online
              system. You need ETA if you wish to visit Sri Lanka as a Tourist,
              on Business or on Transit. No passport copies, documents or
              photographs are required to obtain ETA.
            </p>
          </div>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              Do I need a visa to arrive in Sri Lanka?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              Yes, you need a visa to arrive in Sri Lanka. Apart from that, if
              you’re planning a short visit to Sri Lanka, you’re required to
              obtain Electronic Travel Authorization (ETA) before your arrival.
            </p>
          </div>
        </div>
      </section>
      <section class='relative py-16 bg-white min-w-screen animation-fade animation-delay'>
        <div class='container px-0 px-8 mx-auto sm:px-12 xl:px-5'>
          <h3 class='mt-1 text-2xl font-bold text-left text-gray-800 sm:mx-6 sm:text-3xl md:text-4xl lg:text-5xl sm:text-center sm:mx-0'>
            Language & Communication
          </h3>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              Can I access the Internet for free?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              Most hotels provide internet facilities. Internet cafes with ADSL
              connection are found in most towns. Connections in remote towns
              will be slow. The average cost of surfing in a Cyber Cafe is about
              Euro 0.50 per hour. Many 5 star and some boutique hotels provide
              free WiFi facilities to guests.
            </p>
          </div>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              How do I dial out / within the country?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              Dialing out, you need to dial ’00’and the relevant country code
              before the number. Dialing within the country, inside a particular
              district, say, Colombo, you don’t have to dial its area code (for
              example, just dial 2XXXXXX) But, for an outstation call, you can’t
              do without the area codes.
            </p>
          </div>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              Can I buy a local mobile connection while holidaying?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              Yes. If you have a ‘dual band’ & unlocked phone, you can choose a
              local SIM and top up cards (recharge cards) from several mobile
              operators, namely, Dialog, Mobitel, Etisalat, Hutch and Airtel.
              Every comiunicatio Networks have counters at Katunayake Airport
              arrival lobby where you can buy a connection for Rs. 1500/=
            </p>
          </div>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              What is the country code and how do I dial in?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              Dialing in, Sri Lanka’s country code is 94. To ring a number in
              Colombo, for instance, dial ++94112XXXXXX. If it’s a mobile number
              that you want to call, dial it after the country code. If it’s a
              Mobitel number, for example it should go like ++9471XXXXXXX.
            </p>
          </div>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              What mobile technology is supported in Sri Lanka?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              All mobile operators support the GSM technology on GSM 900 / 1800
              bands. WAP & GPRS is extensively supported. 4G and wireless
              broadband is available in Colombo. Wi-Fi zones are found in
              selected spots in major towns.
            </p>
          </div>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              Which Language(s) will people understand / communicate?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              While Sinhala language is the official & most widely spoken
              language in the country, English is a link language which is
              generally understood by most people. English is spoken at all
              hotels, major restaurants and shops. Road signs are mostly written
              both in Sinhalese & English.
            </p>
          </div>
        </div>
      </section>
      <section class='relative py-16 bg-white min-w-screen animation-fade animation-delay'>
        <div class='container px-0 px-8 mx-auto sm:px-12 xl:px-5'>
          <h3 class='mt-1 text-2xl font-bold text-left text-gray-800 sm:mx-6 sm:text-3xl md:text-4xl lg:text-5xl sm:text-center sm:mx-0'>
            Health & Safety
          </h3>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              How to keep away mosquitoes?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              Most hotels will provide you with a plug-in mosquito repellent
              which may usually be switched on during turn down. You can
              purchase the mats (small repellent tablet inserted to the plug-in
              unit), the burning coils or citronella candles from most local
              supermarkets. Apply some repellent lotion when dining outdoors,
              etc.
            </p>
          </div>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              What health issues must I be concerned with?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              Sri Lanka boasts one of the most reliable healthcare systems in
              the developing world. But emergency medical facilities may not be
              widely available outside of the main cities. Those travelling from
              Africa or Latin America must have a valid certificate of
              vaccination for Yellow fever and Meningitis before the arrival.
            </p>
          </div>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              Is it safe to travel to Sri Lanka?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              Yes. The country is at peace. Tourists visit Sri Lanka in record
              numbers and feel the pervading sense of peace, safety and
              stability as they relish the pristine glory of the small island
              nation. Where we conduct our tours, we also ensure the safety and
              security of our tourists.
            </p>
          </div>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              What safety precautions I should necessarily take when travelling?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              According to accepted norms in traveling, you should put all your
              valuables like money, passport, tickets, jewels etc in the hotel
              safe deposit locker. As the international custom goes, hotels
              aren’t responsible for objects lost in the room. Keep a note of
              your Travelers’ Cheque numbers separately from Travelers’ Cheques.
            </p>
          </div>
        </div>
      </section>
      <section class='relative py-16 bg-white min-w-screen animation-fade animation-delay'>
        <div class='container px-0 px-8 mx-auto sm:px-12 xl:px-5'>
          <h3 class='mt-1 text-2xl font-bold text-left text-gray-800 sm:mx-6 sm:text-3xl md:text-4xl lg:text-5xl sm:text-center sm:mx-0'>
            Food & Lodging
          </h3>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              What type of accommodation can I expect?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              We offer a wide range of accommodation from private boutique
              hotels, villas, eco lodge and tents. But, some of our nature &
              adventure trips involve travelling to remote or undeveloped
              outstation destinations where hotel accommodation of International
              tourist standard may not exist & facilities are relatively poor.
            </p>
          </div>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              Can I smoke in public places?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              No. Smoking and having liquor in public areas is banned in Sri
              Lanka. The smoking ban is also in effect at enclosed public places
              such as restaurants and social clubs.
            </p>
          </div>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              Is it true that liquor is not served on Full Moon days?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              True. Full Moon days (known as Poya days), are of religious
              significance to Buddhists and devoted to prayer and meditation.
              Out of respect for Buddhist religious rites, abstinence is
              practiced. The government has decreed that all liquor shops and
              meat shops & entertainment centres remain closed on Poya days.
            </p>
          </div>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              What other precautions should I take when choosing drinks?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              We advise against drinking tap water unless it is purified. We
              recommend you to use Bottled water in containers with serrated
              seal, but not tops or corks. Most hotel rooms have boiled water in
              thermos flasks, which is safe to drink.
            </p>
          </div>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              How about beer & liquor?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              Sri Lanka has its own variety of local beer. Also, two variations
              of local liquor exist, ie.Toddy & Arrack. Toddy is a natural
              intoxicating drink, tapped from the palm trees. Fermented and
              refined toddy becomes Arrack. Imported beer and foreign liquors
              cost almost the same as in most western countries.
            </p>
          </div>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              What about soft drinks & fruit juice?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              There’s plenty of fresh fruit juice available both in major
              restaurants and smaller ones. It’s as much delectable as healthy.
              Popular international soft drinks are found even in the small
              village boutiques. Thambili or King Coconut is a refreshing sweet,
              clean and cheap natural drink you’ll find by the wayside.
            </p>
          </div>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              What sorts of drinks / beverages can I have?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              First, you can have Ceylon Tea which hailed as the world’s best
              type of tea. If you’re a coffee fan, local coffee may be up to
              your taste, if a little strong. If you long for a good espresso,
              you may get it while in Colombo but not elsewhere.
            </p>
          </div>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              What sort of food can I hope to have in an ‘Ayurveda Resort’?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              The food is exclusively based on Sri Lankan rice and curry menu.
              The curries are mostly Sri Lankan vegetables; chicken and fish may
              be included.
            </p>
          </div>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              Can I get ‘Halal’ food?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              ‘Halal’ food isn’t much common in major hotels. The Galadari and
              Holiday Inn in Colombo serve halal food as does the Confifi group
              of hotels (Eden, Riverina & Club Palm Garden). Apart from the
              Halal restaurants in Colombo and Kandy, they’re hardly elsewhere.
              The best alternative seems to be seafood.
            </p>
          </div>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              Can I get vegetarian food?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              Star hotels and major restaurants sport a ‘vegetarian section’ in
              the menu. The smaller local ‘rice and curry’ restaurants may claim
              the food is vegetarian, but it often includes a serving of fried
              fish or sprats (anchovies). However, the ‘South Indian’ vegetarian
              restaurants are purely vegetarian.
            </p>
          </div>
        </div>
      </section>
      <section class='relative py-16 bg-white min-w-screen animation-fade animation-delay'>
        <div class='container px-0 px-8 mx-auto sm:px-12 xl:px-5'>
          <h3 class='mt-1 text-2xl font-bold text-left text-gray-800 sm:mx-6 sm:text-3xl md:text-4xl lg:text-5xl sm:text-center sm:mx-0'>
            Money & Banking
          </h3>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              What are the business hours and days?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              Insert the table
            </p>
          </div>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              Why don’t Sri Lankan banks have IBAN account numbers?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              Instead of International Bank Account Numbers (IBAN), Sri Lanka
              like most other Asian countries, USA and Australia use the current
              Bank Identifier Code system (BIC or SWIFT code) along with the
              BBAN (Basic Bank Account Number).
            </p>
          </div>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              Are ATM machines available throughout the country and do they
              issue cash for my debit/ credit card?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              ATMs are located in most of the cities. You’re allowed to take
              cash against Visa / Mastercard in most ATMs. However, as different
              banks accept different cards, we recommend you to ensure that your
              card is valid for use in Sri Lanka by contacting your bank. Watch
              out for the Maestro or Cirrus logo!
            </p>
          </div>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              Are credit card charges made in foreign currency?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              No, they aren’t. Due to exchange regulations in the country, local
              establishments will determine your payments by applying the
              exchange rate prevailing at the date of payment.
            </p>
          </div>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              Are credit cards accepted everywhere?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              Credit Cards are extensively used and accepted by local
              establishments (even in small towns). The most popular card types
              are Visa and MasterCard, with Amex being used to a lesser extent.
              It’d be a convenient option to use your Credit Card (valid for
              international use) whenever possible.
            </p>
          </div>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              Where can I re-exchange?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              The Re-Exchange (purchase of foreign currency) can only take place
              on your departure at the Bank counters at the airport. Remember
              that they will only accept bank receipts (not Money Changer
              receipts).
            </p>
          </div>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              What’re requirements for re-exchanging?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              Please keep with you whatever receipts of exchange (including ATM
              receipts) for monies declared. This will be useful when
              re-exchanging to foreign currency and taking your money back out
              of the country.
            </p>
          </div>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              How much of money can I take out of the country?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              If you intend to take out from Sri Lanka a sum exceeding US
              $5000(or its equivalent in Euro or some other currency) in
              currency notes (out of the money brought in), you must declare the
              total amount brought in, even if it’s less than US$ 15,000.
            </p>
          </div>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              How much of money can I bring into the country?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              You can bring any amount of money in foreign currencies into Sri
              Lanka. It could be in TCs, Bank drafts or currency notes. But, if
              the total is more than US $15,000 (or its equivalent in Euro or
              some other currency) that sum must be declared to Sri Lanka
              Customs.
            </p>
          </div>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              How about the bank fees for foreign currency exchange?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              Banks take 0.5% handling fee and generally a commission, which
              differs from bank to bank. We recommend you to convert only that
              amount of money you need for spending.
            </p>
          </div>
        </div>
      </section>
      <section class='relative py-16 bg-white min-w-screen animation-fade animation-delay'>
        <div class='container px-0 px-8 mx-auto sm:px-12 xl:px-5'>
          <h3 class='mt-1 text-2xl font-bold text-left text-gray-800 sm:mx-6 sm:text-3xl md:text-4xl lg:text-5xl sm:text-center sm:mx-0'>
            Clothes & Accessories
          </h3>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              Can you recommend a rough pack-list?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              Try getting a sarong. It’s very light, comfortable and packs down
              to almost nothing; also it suits all purposes and occasions,
              including the temple etiquette.
            </p>
          </div>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              How should I be dressed if I visit a Buddhist or Hindu Temple?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              You should take off your shoes and hat when entering a Buddhist or
              Hindu temple. If you’re carrying an umbrella, unfurl it. Your legs
              & shoulders should be covered; never enter a temple in beach wear
              (i.e. shorts or singlet) and It,s better if you can dress white
              color or lighter color, when you visit Buddhist temple.
            </p>
          </div>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              Is there any particular dress code that I’m supposed to follow?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              It’s advisable to bring one set of Evening wear as larger hotels
              insist on ‘long attire’ for men during dinner (no shorts and no
              sandals). Ladies could come in dresses, skirts or long shorts, but
              not in any beach / swimwear.
            </p>
          </div>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              What type of clothes should I pack?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              Lightweight, light coloured cotton clothes are ideal for the warm
              climes of a tropical country like Sri Lanka. We’d like to
              recommend that you pack some warm clothes if you are planning to
              visit the hilly regions, where the evenings tend to get chilly.
            </p>
          </div>
        </div>
      </section>
      <section class='relative py-16 bg-white min-w-screen animation-fade animation-delay'>
        <div class='container px-0 px-8 mx-auto sm:px-12 xl:px-5'>
          <h3 class='mt-1 text-2xl font-bold text-left text-gray-800 sm:mx-6 sm:text-3xl md:text-4xl lg:text-5xl sm:text-center sm:mx-0'>
            Travelling & Photography
          </h3>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              When is the best time to travel?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              The best & driest seasons are from December to April on the West &
              South Coasts and in the hill country, and from May to September in
              the East Coast.
            </p>
          </div>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              Are there other options to process my digital photos?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              It’s always advisable to bring a USB cord (camera to PC) so you
              transfer the pictures to a PC. Internet cafés are ideal for this.
              Simply copy the pictures to the PC and then burn them into a CD.
              This is much cheaper and can keep your memory cards empty.
            </p>
          </div>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              Can I process my digital photos in Sri Lanka?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              There are many franchised photo shops such as Kodak & Fuji with
              advanced digital imaging services in major towns. Almost all types
              of digital data storage devices are accepted. It’s always
              advisable to keep a backup of your pictures before handing it over
              for processing.
            </p>
          </div>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              Are there any places I should avoid photographing for military
              reasons?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              Never take photos of dams, airports, roadblocks or anything to do
              with the military. Don’t shoot with cameras around Colombo Fort.
            </p>
          </div>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              Should I pay for taking photographs of people or places?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              Tourists are sometimes asked for money for taking photos. Always
              ask before you photograph whether payment is expected. Our
              accompanying representatives will be able to guide you on this.
            </p>
          </div>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              Are there any other special concerns I should be aware of?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              You aren’t allowed to use cammara at the frescoes at Sigiriya, but
              where there is no ban, please behave responsibly. Never pose
              beside or in front of a Buddha statue (i.e. with your back to the
              statue). Such conduct is considered extremely disrespectful also
              dont try to take a photo in front os loard buddha's statue with
              people. Don’t photograph a monk without asking permission.
            </p>
          </div>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              Can I photographs inside temples and monasteries?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              Ask permission before taking pictures either of people or inside
              temples or other sacred places. For example, it is forbidden to
              take photographs inside the cave temple complex of Dambulla. Never
              use flash on murals inside temples and other places; it can cause
              damage them.
            </p>
          </div>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              What are the do’s and don’ts of local photography?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              Ask permission before taking photographs of people and respect
              their decision if they refuse. Minority groups in particular are
              often unhappy to be photographed. If photos are taken, kindly send
              back copies (through our tour leaders or direct to the village) so
              that the people receive copies.
            </p>
          </div>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              What if I travel out of season?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              Out of season travel has its own benefits; while the big crowds go
              away, most airfares & accommodation prices too go down, with many
              special offers thrown in. On the coast the average temperature
              remains around 27°C. The temperature rapidly falls as the altitude
              gets higher & higher.
            </p>
          </div>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              How about the rainy seasons?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              Sri Lanka experiences two monsoons; the rainy season in the East
              coast is the dry season in the south west coast & vice versa. This
              makes Sri Lanka a year around destination, and there is always a
              ‘right’ season somewhere in the island.
            </p>
          </div>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              How about the Temperature?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              🌡 Temperature in Colombo and suburbs varies from Centigrade <br />
              🌡 Temperature in Central hills and other higher elevations are
              Centigrade 14 - 16
              <br />
              🌡 As 100 meters rise-up the altituge, one Centigrade of
              temperature goes down <br />
              🌡 Average yearly temperature for the country from Centigrade 26 -
              28 <br />
              🌡 Decwember and january are the coolest months and March to May,
              the hottest months. <br />
              🌡 Normally day and night temprature vary from Centigrade 4 - 7
            </p>
          </div>
        </div>
      </section>
      <section class='relative py-16 bg-white min-w-screen animation-fade animation-delay'>
        <div class='container px-0 px-8 mx-auto sm:px-12 xl:px-5'>
          <h3 class='mt-1 text-2xl font-bold text-left text-gray-800 sm:mx-6 sm:text-3xl md:text-4xl lg:text-5xl sm:text-center sm:mx-0'>
            Shopping & Entertainment
          </h3>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              How much should I tip?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              Your housekeeping staff, doorman, bellboy all expect a little tip.
              A tip between 100 – 200 rupees ( 1-2 USD) for each service is
              considered adequate. You guide or driver on tour will expect
              something between US$ 5 to 15 a day (depending on your level of
              satisfaction).
            </p>
          </div>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              Is tipping accepted?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              Tipping is accepted. Although a 10% service charge is included in
              bills for food and accommodation, tipping is a customary way of
              showing your appreciation for services rendered.
            </p>
          </div>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              How about the nightlife in Sri Lanka?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              The places with some active night life are Colombo, Negombo and
              Hikkaduwa. Colombo has some decent pubs, night clubs, karaoke
              lounges and bars. There is a growing pub-culture among the young
              crowd in Colombo. Friday and Saturday nights are the days for all
              night partying.
            </p>
          </div>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              What should I specially shop for?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              Sri Lanka has a wide variety of splendid handicraft on sale. Sri
              Lankan masks are a very popular collector’s item. Other
              recommendations are batiks, wood carvings, gemstones, semi-
              precious stones, lacquer-ware, handmade Silver- and Brass objects
              and don’t forget the famous ‘Ceylon Tea’.
            </p>
          </div>
        </div>
      </section>
      <section class='relative py-16 bg-white min-w-screen animation-fade animation-delay'>
        <div class='container px-0 px-8 mx-auto sm:px-12 xl:px-5'>
          <h3 class='mt-1 text-2xl font-bold text-left text-gray-800 sm:mx-6 sm:text-3xl md:text-4xl lg:text-5xl sm:text-center sm:mx-0'>
            Local Customs and Etiquette
          </h3>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              What are the dos and don’ts when mingling with locals?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              Always give and receive and eat with your right hand. It is
              extremely bad mannered to use your left hand for eating. Respect
              cultural differences, the local laws & import regulations and make
              sure your behavior doesn’t violate environmental responsibility.
            </p>
          </div>
          <div
            class='w-full px-6 py-6 mx-auto mt-10 bg-white border border-gray-200 rounded-lg sm:px-8 md:px-12 sm:py-8 sm:shadow lg:w-5/6 xl:w-2/3'
            data-aos='fade-up'
          >
            <h3 class='text-lg font-bold text-purple-500 sm:text-xl md:text-2xl'>
              Where can I discover more information about the country in
              general?
            </h3>
            <p class='mt-2 text-base text-gray-600 sm:text-lg md:text-normal'>
              Visit the official Sri Lanka Tourism website for more information.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Questions;
